const state = {
  mainHeight: 0,
  mainWidth: 0,
  sideHeight: 0,
  containerHeight: 0,
  tabHeight: 0,
  mtableHeight: 0,
  dtableHeight: 0,
  menuWidth: 0
}
const getters = {
  mainHeight_ (state) {
    return state.mainHeight
  },
  mainWidth_ (state) {
    return state.mainWidth
  },
  sideHeight_ (state) {
    return state.sideHeight
  },
  containerHeight_ () {
    return state.containerHeight
  },
  tabHeight_ () {
    return state.tabHeight
  },
  mtableHeight_ () {
    return state.mtableHeight
  },
  dtableHeight_ () {
    return state.dtableHeight
  },
  menuWidth_ () {
    return state.menuWidth
  }
}
const mutations = {
  setMainHeight (state, height) {
    state.mainHeight = height
  },
  setMainWidth (state, width) {
    state.mainWidth = width
  },
  setSideHeight (state, height) {
    state.sideHeight = height
  },
  setContainerHeight (state, height) {
    state.containerHeight = height
  },
  setTabHeight (state, height) {
    state.tabHeight = height
  },
  setMtableHeight (state, height) {
    state.mtableHeight = height
  },
  setDtableHeight (state, height) {
    state.dtableHeight = height
  },
  setMenuWidth (state, width) {
    state.menuWidth = width
  }
}
const actions = {

}
export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
}
